export const locales = {
  tr: {
    welcomeTitle: "Merhaba! Ben Pardon AI.",
    welcomeSubtitle: "Bugün size nasıl yardımcı olabilirim?",
    inputPlaceholder: "Pardon AI'ya sorun...",
    disclaimerText: "Demo sürümüdür. Hatalar olabilir, lütfen bilgileri garsonunuzdan doğrulayın.",
    thinkingMessage: "Düşünüyorum...",
    errorMessage: "Üzgünüm, şu anda isteğinizi işleyemiyorum. Lütfen biraz sonra tekrar deneyin.",
    messageLimitReached: "⚠️ Mesaj sınırına ulaştınız. Lütfen yeni sohbet başlatın.",
  },

  en: {
    welcomeTitle: "Hello! I'm Pardon AI.",
    welcomeSubtitle: "How can I assist you today?",
    inputPlaceholder: "Ask Pardon AI...",
    disclaimerText: "Demo version. Errors may occur, please verify information with your waiter.",
    thinkingMessage: "Thinking...",
    errorMessage: "Sorry, I can't process your request right now. Please try again later.",
    messageLimitReached: "⚠️ Message limit reached. Please start a new chat.",
  }
};

export const defaultLanguage = 'tr';
